import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import ResetMain from "../../components/resetMain";
import AuthRedirect from "../../components/authRedirect";



const ResetPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Восстановление пароля')}/>
            <AuthRedirect/>
            <ResetMain/>
        </section>
    );
};

export default ResetPage;